export default "__VITE_ASSET__DUBa22qG__"